var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 64,
    rx: 20,
    fill: "#03D3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9016 31.4476C26.963 31.4376 27.0251 31.433 27.0872 31.4338H37.6694L37.4387 31.3265C37.2131 31.2197 37.0079 31.0744 36.8323 30.8972L33.8648 27.9297C33.474 27.5566 33.4083 26.9564 33.7092 26.5076C34.0593 26.0294 34.7309 25.9256 35.2091 26.2757C35.2478 26.304 35.2845 26.3349 35.319 26.3681L40.6852 31.7343C41.1046 32.1532 41.105 32.8327 40.6861 33.2521C40.6858 33.2524 40.6855 33.2527 40.6852 33.253L35.319 38.6192C34.8993 39.0377 34.2198 39.0368 33.8012 38.6171C33.7683 38.584 33.7375 38.5489 33.7092 38.5118C33.4083 38.0631 33.474 37.4629 33.8648 37.0898L36.8269 34.1169C36.9844 33.9593 37.1654 33.8271 37.3635 33.7252L37.6855 33.5803H27.1463C26.598 33.6007 26.117 33.2177 26.014 32.6788C25.9191 32.0937 26.3165 31.5425 26.9016 31.4476Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(-1 0 0 1 41 25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.6d5b552d1b53306a3ec277a93712b22d.svg";
export { ForwardRef as ReactComponent };